<template>
  <div>
    <div class="top-bar" :class="[isCollapse ? 'collapse' : '']">
      <el-dropdown class="user-info" @command="handleCommand">
      <span class="el-dropdown-link">
        {{nickName}} <i class="iconfont icon-arrow-down-fill"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">注销登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="catch-bar">
        <TagsView></TagsView>
      </div>
    </div>
    <PwdDialog v-if="isShowPwd" :isShowPwd.sync="isShowPwd"/>
  </div>
</template>

<script>
  import TagsView from '../TagsView'
  import PwdDialog from './PwdDialog'
  import {mapGetters} from 'vuex'

  export default {
    props: ['isCollapse'],
    components: {
      TagsView,
      PwdDialog
    },
    computed: {
      ...mapGetters([
        'nickName'
      ])
    },
    data() {
      return {
        isShowPwd: false
      }
    },
    methods: {
      handleCommand(command) {
        if (command === 'pwd') {
          this.isShowPwd = true;
        }
        if (command === 'logout') {
          this.logout();
        }
      },
      logout() {
        this.$confirm('确认注销登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('user/logout')
        }).catch(() => {
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/variables";

  .top-bar {
    position: fixed;
    z-index: 101;
    top: 0;
    width: calc(100vw - 150px);
    left: $sideBarWidth;
    height: 60px;
    background: #fff;
    border-bottom: 1px solid #e7eaec;
    padding: 0 20px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    &.collapse {
      left: $sideBarMiniWidth;
      width: calc(100vw - 54px);
    }
  }

  .catch-bar {
    overflow: hidden;
  }

  .user-info {
    margin-top: 20px;
    float: right;
    color: #999c9e;
    cursor: pointer;
    padding-left: 20px;
    .iconfont {
      font-size: 12px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/layout/components/TopBar/index.vue